var chunkMapping = {
	"2509": [
		52509
	],
	"3002": [
		3002
	],
	"3076": [
		3076
	],
	"3301": [
		33301
	],
	"3666": [
		93666
	],
	"5712": [
		45712
	],
	"5819": [
		45819
	],
	"6892": [
		46892
	],
	"9441": [
		9441
	]
};
var idToExternalAndNameMapping = {
	"3002": [
		"default",
		"./Activities",
		85678
	],
	"3076": [
		"default",
		"./translations",
		59856
	],
	"9441": [
		"default",
		"./App",
		68641
	],
	"33301": [
		"default",
		"./SettingsBasic",
		59856
	],
	"45712": [
		"default",
		"./translations",
		85678
	],
	"45819": [
		"default",
		"./SettingsAdvanced",
		59856
	],
	"46892": [
		"default",
		"./translations",
		68641
	],
	"52509": [
		"default",
		"./UnreadRequestsCount",
		68641
	],
	"93666": [
		"default",
		"./UnreadRequests",
		68641
	]
};
var idToRemoteMap = {
	"3002": [
		{
			"externalType": "script",
			"name": "RemoteActivities",
			"externalModuleId": 85678
		}
	],
	"3076": [
		{
			"externalType": "script",
			"name": "RemoteWidget",
			"externalModuleId": 59856
		}
	],
	"9441": [
		{
			"externalType": "script",
			"name": "RemoteInbox",
			"externalModuleId": 68641
		}
	],
	"33301": [
		{
			"externalType": "script",
			"name": "RemoteWidget",
			"externalModuleId": 59856
		}
	],
	"45712": [
		{
			"externalType": "script",
			"name": "RemoteActivities",
			"externalModuleId": 85678
		}
	],
	"45819": [
		{
			"externalType": "script",
			"name": "RemoteWidget",
			"externalModuleId": 59856
		}
	],
	"46892": [
		{
			"externalType": "script",
			"name": "RemoteInbox",
			"externalModuleId": 68641
		}
	],
	"52509": [
		{
			"externalType": "script",
			"name": "RemoteInbox",
			"externalModuleId": 68641
		}
	],
	"93666": [
		{
			"externalType": "script",
			"name": "RemoteInbox",
			"externalModuleId": 68641
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}